import React from 'react'

export const BlackboardTitle = () => {

  return (
    <React.Fragment>
      <div className="d-flex justify-content-center mr-2 mb-2" width="500px">
        <img
          width="31rem"
          src="/static/instructor/media/blackboard.svg"
          className="mr-4"
        />
        <h1>Blackboard</h1>
      </div>
    </React.Fragment>
  )
}
